<template>
  <div class="options-chart">
    <div>
      <div v-for="(option, index) in options" :key="index">
        <div class="options" :class="[classByLength, classBySelected(index)]" v-on:click="setSelectedIndex(index)">{{ option.name }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <datetime-line-chart
          :filterParams="filterParams"
          class="chart-card"
          :key="selectedIndex"
          :uniqueName="options[selectedIndex].uniqueName"
          :type="this.options[selectedIndex].type"
          :height="this.options[selectedIndex].height"
          :trendline="this.options[selectedIndex].trendline"
          :showBrush="this.options[selectedIndex].showBrush"
          :name="this.options[selectedIndex].name">
        </datetime-line-chart>
      </div>
    </div>
  </div>
</template>

<script>
import DatetimeLineChart from './DatetimeLineChart'

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    filterParams: {
      type: Object
    }
  },

  data () {
    return {
      selectedIndex: 0
    }
  },

  methods: {
    setSelectedIndex (index) {
      this.selectedIndex = index
    },

    classBySelected (index) {
      if (this.selectedIndex === index) {
        return 'selected'
      }
      return null
    }
  },

  computed: {
    classByLength () {
      switch (this.options.length) {
        case 1 :
          return 'col-xs-12'
        case 2 :
          return 'col-xs-6'
        case 3 :
          return 'col-xs-4'
        case 4 :
          return 'col-xs-3'
        default :
          return 'col-xs-2'
      }
    },
    selectedClass (index) {
      if (this.selectedIndex === index) {
        return 'selected'
      }
      return null
    }
  },

  components: {DatetimeLineChart}
}
</script>
